<div fxLayout="column" fxLayoutGap="15px">
  <div fxFlex="100">
    <mat-form-field fxFlex="100">
      <mat-label>Dynamika sprzedaży</mat-label>
      <input appCapitalizeFirst matInput placeholder="Dynamika sprzedaży" [formControl]="currentDynamicsControl" [required]="false">
    </mat-form-field>
  </div>

  <div fxLayout="row">
    <span fxFlex></span>

    <button
      mat-raised-button (click)="sendForm()" color="primary"
      [class.spinner]="processingRequest" [disabled]="processingRequest"
    >Zapisz</button>
  </div>
</div>
